import React, { useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withSocket } from "../../../socket/context";
import _ from "lodash";
import Player from "../../../assets/images/tot/players.png";
import Players from "./players";
import Masonry from "react-masonry-css";
import { removeUser } from "../../../components/shared/utils";

const TotGame = (props) => {
  const [allUsers, setAllUsers] = useState(props.gameReducer.roomObj.users);
  const comparer = (otherArray) => {
    return function (current) {
      return (
        otherArray.filter(function (other) {
          return other.player_id === current.player_id;
        }).length === 0
      );
    };
  };
// new audio experiment 
  const playVoice = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none"; //added to fix ios issue
    audio.autoplay = true; //avoid the user has not interacted with your page issue
    audio.onended = function () {
      audio.remove(); //remove after playing to clean the Dom
    };
    document.body.appendChild(audio);
  };

  useEffect(() => {
    let { gameReducer, usersChanged } = props;
    let roomObj = _.get(gameReducer, "roomObj");
    if (
      usersChanged &&
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length > 0
    ) {
      if (roomObj.users.length > allUsers.length) {
        let result = roomObj.users.filter(comparer(allUsers));
        playAudio(
          result && result[0].audio_effect ? result[0].audio_effect : ""
        );
        setAllUsers(roomObj.users);
      }
    }
    if (
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length < allUsers.length
    ) {
      setAllUsers(roomObj.users);
    }
  }, [props.gameReducer.roomObj]);

  const playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none"; //added to fix ios issue
    audio.autoplay = true; //avoid the user has not interacted with your page issue
    audio.onended = function () {
      audio.remove(); //remove after playing to clean the Dom
    };
    document.body.appendChild(audio);
  };

  const delPlayer = (data) => {
    const roomObj = props.gameReducer.roomObj;
    removeUser(roomObj, data);
  };
  const { paramsReducer } = props;
  const params = _.get(paramsReducer, "gameObj.screens", {}) || {};
  // const lobby = _.get(params, "lobby", {}) || {};
  const playersLabel = _.get(params, "lobby.players_label", "Players");
  const playerLimitLabel = _.get(params, "lobby.players_label", "");

  return (
    <div className="flex-grow-1">
      <div className="tot-players-wrapper">
        {/* <p className="mb-0 tot-game-title">
          {playerLimitLabel}({allUsers.length}/10)
        </p> */}
        <p className="mb-0 tot-game-title">
          <img src={Player} />({allUsers.length}/10)
        </p>

        <div className="tot-players">
          <div className="team-list-wrap">
            <Masonry
              breakpointCols={2}
              className="my-masonry-grid"
              columnClassName="my-masonry-grid_column masonry-col"
            >
              {allUsers &&
                allUsers.length > 0 &&
                allUsers.map((data, index) => (
                  <Players key={index} {...data} deletePlayer={delPlayer} />
                ))}
            </Masonry>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer,
});
export default compose(withSocket, connect(mapStateToProps, null))(TotGame);
